/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Revisión de IA',
    AIReviewFailed: 'La revisión de IA falló',
    AIReviewPassed: 'La revisión de IA pasó',
    AIReviewStatus: 'Estado de revisión de IA',
    AIReviewing: 'La revisión de IA se está revisando',
    America: 'Estados Unidos',
    CheckSupportInstall: 'Comprobar si se admiten modificaciones',
    ImporterCommunityDisplayName: 'Nombre de la comunidad del importador',
    ImporterContactEmail: 'Correo electrónico de contacto del importador',
    IndicatorLight: 'Luz indicadora',
    Instruction: 'Aviso',
    MostPicture4OrVideo: '(Máximo 4 fotos / 1 vídeo)',
    PleaseContactPersonnelCommunicating: 'Póngase en contacto con el personal de CFMOTO para cualquier consulta',
    Redemptionservice: 'Servicio de canje',
    USD: 'USD',
    UnbindingApplicationCommitment: 'Solicitud de compromiso de desvinculación',
    aboutAccount: 'Acerca de la cuenta',
    aboutVehicle: 'Sobre el vehículo',
    accountApplyRejected: 'Solicitud de eliminación de cuenta rechazada',
    accountCancel: 'Solicitud de eliminación de cuenta',
    accountDeletExplain: 'Guía de eliminación de cuenta',
    accountDelete: 'Eliminación de cuenta',
    accountDeleted: 'Cuenta eliminada',
    accountFormatError: 'Formato de cuenta incorrecto/Usuario no existe.  Haga coincidir el texto correspondiente con la causa real',
    accountNumber: 'Número de cuenta',
    action: 'Operación',
    actionFail: 'Operación fallida',
    actionSuccess: 'Operación realizada con éxito',
    activeScore: 'Puntuación activa',
    activeTrigger: 'Los usuarios activan activamente (Acerca de la aplicación: ir a la calificación)',
    activity: 'Actividad',
    activityCancel: 'Cancelación del evento',
    activityCover: 'Portada de actividad',
    activityDetails: 'Detalles de actividad',
    activityId: 'ID de actividad',
    activityList: 'Lista de actividades',
    activityManagement: 'Gestión de actividades',
    activitySearch: 'Consulta de actividades',
    activityTime: 'Tiempo de actividad',
    activityTitle: 'Título de actividad',
    activityVenue: 'Lugar de actividad',
    adaptable: 'Aplicable a',
    add: 'Añadir',
    addAccountDeletExplain: 'Añadir notificación de supresión de cuenta',
    addAuthenticationTime: 'Añadir tiempo de autenticación',
    addCanadaPrivacyPolicy: 'Agregar política de privacidad de Canadá',
    addCanadaTelematicsPolicy: 'Agregar acuerdo telemático de Canadá',
    addCanadaUserPolicy: 'Agregar acuerdo de usuario canadiense',
    addDashcamHelp: 'Añadir ayuda de Dashcam',
    addDataDeletExplain: 'Añadir notificación de eliminación de datos',
    addEmail: 'Nuevo email',
    addExhibitionCategory: 'Añadir Categoría de Tienda',
    addExhibitionSeries: 'Agregar Nueva Serie',
    addHelpConfiguration: 'Añadir ayuda para explicar la configuración',
    addInformationCategory: 'Agregar nueva categoría de información',
    addInformationContent: 'Agregar nuevo contenido de información',
    addKolUserAuthentication: 'Añadir autenticación de usuario KOL',
    addPicture: 'Añade una foto',
    addPrivacyAgreement: 'Añadir Protocolo de privacidad',
    addPrivacySubmitSure: 'La fecha de entrada en vigor y la descripción del cambio de la nueva política de privacidad no se pueden ajustar después del envío. ¿Confirmar envío?',
    addPushConfiguration: 'Añadir configuración de push',
    addQuestion: 'Agregar pregunta',
    addSdkStaement: 'Añadir declaración del SDK',
    addServiceIntroduce: 'Introducción de nuevos servicios',
    addShowroomModel: 'Añadir modelos de sala de exposiciones',
    addThisUser: 'Añadir este usuario',
    addTopic: 'Añadir un tema',
    addUser: 'Añadir usuario',
    addUserAgreement: 'Añadir Protocolo de usuario',
    addUserRole: 'Añadir rol de usuario',
    addVehicleModel: 'Nuevos modelos',
    addVehicleModelCategory: 'Nuevas categorías de modelos',
    addVideo: 'Añadir video',
    addedBy: 'Añadido por',
    additionalFeedback: 'Comentarios adicionales',
    administratorUnbind: 'Desvinc. del admin.',
    afternoon: 'Tarde',
    agreeServiceAgreement: 'Al activar el servicio, acepta el Acuerdo de servicio',
    agreeSignOut: 'Aceptar la terminación',
    agreementContent: 'Acuerdo',
    all: 'Todo',
    allArea: 'País/región de destino',
    allComment: 'Todos los comentarios',
    allImportSuccess: 'Importación completada. Todo importado con éxito.',
    allServicesSimultaneously: 'Todos los servicios',
    allUser: 'Todos los usuarios',
    allVehicleModel: 'Todos los modelos',
    alreadyOver: 'No se encuentran archivos aqui',
    ambientLightControl: 'Control de luz ambiental',
    amount: 'Monto',
    android: 'Android',
    answer: 'Respuesta',
    answerOta1: 'OTA significa que el vehículo descarga el último software de firmware desde la nube a través de la red celular, y puede actualizar el vehículo en línea a través de CFMOTO RIDE para optimizar continuamente la experiencia de conducción',
    answerOta2:
      'Cuando se muestre una nueva versión del tft que se pueda actualizar, recibirá la notificación de actualización. Si se muestra %s en la parte inferior de la página actual, significa que no es necesario actualizar la pantalla tft del vehículo.',
    answerOta3: 'Puede hacer clic en %s en la esquina superior derecha para obtener más instrucciones de operación OTA con anticipación.',
    anyCar: '¿Hay algún vehículo?',
    appMessagePushCountLimit: 'Ha alcanzado el límite de notificaciones de este mes (2 veces/mes). El contenido editado puede guardarse como borrador. ¿Desea guardarlo?',
    appPush: 'Notificación de la app',
    appRating: 'Gestión del mecanismo de puntuación',
    appType: 'Sistema telefónico',
    appVersion: 'Version de aplicacion',
    applicableCountry: 'País aplicable',
    applicableCountryName: 'Países aplicables',
    applyTime: 'Tiempo de aplicación',
    applyUnbinding: 'Aplicar la desvinculación',
    appointmentReleaseTime: 'Hora de liberación de la cita',
    approval: 'Aprobar',
    arrivalNumberDescription: 'Número de dispositivos que recibieron la notificación',
    arrivalNumberDescription0: 'El número real de llegadas al terminal del dispositivo tras el envío del mensaje de notificación (no se contarán las llegadas después de 5 días)',
    arrivalNumberVolume: 'Número de llegadas',
    askAllowUserSpeakInCommunity: '¿Permitir al usuario baneado publicar en la comunidad',
    askApproveIt: '¿Aprobarlo',
    askDeleteCategory: '¿Eliminar esta categoría',
    askDeleteInformactionCategory: '\n¿Eliminar esta categoría de información?',
    askDeleteInformationContent: '¿Eliminar contenido informativo?',
    askDeleteKolUserAuthentication: '¿Está seguro de eliminar esta autenticación de usuario KOL?',
    askDeleteOfficialAuth: '¿Seguro que desea eliminar la autorización oficial de esta cuenta?',
    askDeleteQuestion: '¿Quieres eliminar esta pregunta',
    askDeleteThisActivity: '¿Eliminar esta actividad',
    askDeleteThisBanner: '¿Eliminar este Banner',
    askDeleteThisComment: '¿Estás seguro de que quieres borrar este comentario',
    askDeleteThisPost: '¿Eliminar esta publicación',
    askDeleteThisTopic: '¿Eliminar este tema',
    askDeleteVehicleType: '¿Eliminar el modelo de vehículo?',
    askDeleteVehicleTypeCategory: '¿Eliminar esta categoría de modelo?',
    askDeleteVehicleTypeDetails: '¿Eliminar los detalles del modelo?',
    askDeleteVehicleTypeSeries: '¿Eliminar esta serie de modelos?',
    askLogout: '¿Seguro que quiere salir del sistema?',
    askNotApproveIt: '¿No aprobarlo',
    askSaveSettings: 'La configuración aún no se ha guardado, ¿quieres guardarla?',
    associatedPostNumber: 'Número de publicaciones asociadas',
    associatedPosts: 'Publicaciones asociadas',
    associatedVehicle: 'Vehículo asociado',
    assoclatedContent: 'Contenido asociado',
    atmosphereCContent: 'La configuración aún no se ha guardado, ¿quieres guardarla?',
    atmosphereContent1Msg1: 'Una vez activada la función, el teléfono móvil enciende el Bluetooth y la APP sigue funcionando. Al acercarse al vehículo de lejos a cerca, el vehículo se puede desbloquear y encender automáticamente.',
    atmosphereContent1Msg2: 'Si normalmente no está desbloqueado y encendido, presione el botón de encendido del vehículo para desbloquear y encender.',
    atmosphereContent1Msg3: 'El desbloqueo automático de proximidad solo se activará una vez antes de que se desconecte el Bluetooth.',
    atmosphereContent2Msg1: 'Después de activar la función, el vehículo se apagará automáticamente 5 segundos después de que se cumplan 3 condiciones: el motor esté apagado, la velocidad del vehículo sea 0 y el caballete lateral esté bajado.',
    atmosphereContent2Msg2: 'El apagado automático se cancelará si no se cumplen estas 3 condiciones.',
    atmosphereContent3Msg1:
      'Una vez encendida la función, cuando el vehículo está apagado, el teléfono móvil enciende el Bluetooth y la APP sigue funcionando. Al acercarse al vehículo de lejos a cerca, las luces del vehículo parpadearán para dar la bienvenida a los invitados.',
    atmosphereContent3Msg2: 'Para evitar que los disparadores frecuentes provoquen una pérdida de potencia del vehículo, después de que la función de bienvenida se active dos veces en 30 segundos, no se reanudará hasta 30 minutos después.',
    atmosphereContent4Msg1: 'Después de encender la función, las luces de haz bajo y lejano se encenderán automáticamente durante 10 segundos después de que el vehículo se apague',
    atmosphereIntroduce1: 'Instrucciones de desbloqueo automático',
    atmosphereIntroduce2: 'Instrucciones de apagado automático',
    atmosphereIntroduce3: 'Instrucciones de activación automática',
    atmosphereIntroduce4: 'Apagado de luces retrasado',
    atmosphereSetINfo: 'Las nuevas configuraciones surtirán efecto dentro de 1 a 3 minutos después de encender el vehículo, asegúrese de que el vehículo esté en una buena posición de señal.',
    auditStatus: 'Estado de revisión',
    authType: 'Tipo de autorización',
    authenticatedName: 'Nombre autenticado',
    avatar: 'Foto de perfil',
    backApply: 'Retirar aplicación',
    backApplySuccess: 'Retirada de la solicitud exitosa',
    backHome: 'Volver a la página de inicio',
    bannerDisplayImages: 'Imagen del cartel',
    bannerList: 'Lista de Banners',
    bannerManagement: 'Gestión de Banners',
    bannerPictrure: 'Dibujo de Banner',
    bannerSearch: 'Consulta de Banners',
    bannerTitle: 'Título del banner',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Pago de Standard Edition',
    baseServiceResetTimeRule: 'La hora de reinicio del servicio básico no puede ser posterior a la hora actual',
    batchImport: 'Importación por lotes',
    batchUser: 'Usuarios masivos',
    beijingTime: 'Hora UTC+8',
    belogCategory: 'Categoría',
    belongCategory: 'Categoría Pertinente',
    bindDevice: 'Dispositivo de unión',
    bindEmail: 'Vincular correo electrónico',
    bindVehicle: 'Atar vehículo',
    bindingStatus: 'Estado de vinc.',
    bindingText1: '1.\tServicios Telemáticos',
    bindingText10: '1.1.2.\tProporcionar planificación de rutas durante la navegación, incluido el cálculo de la distancia entre vehículos y la navegación a pie con el fin de encontrar un vehículo .',
    bindingText11: '1.2.\tEnvío de las notificaciones necesarias al Cliente en función de las condiciones del vehículo.',
    bindingText12:
      '1.2.1.\tCFMOTO enviará notificaciones al Cliente sobre el mantenimiento del vehículo (por ejemplo, en función de la distancia total que condujo el Cliente, el momento en que el Cliente compró el vehículo, el tiempo o los requisitos de distancia de conducción para el mantenimiento del vehículo) .',
    bindingText13:
      '1.2.2.\tCon base en los datos del vehículo , CFMOTO enviará al Cliente notificaciones de situaciones anormales; incluyendo análisis de datos por OEM (dependiendo del modelo) para brindar atención al cliente y optimización del seguimiento del vehículo .',
    bindingText14: '1.3.\tApoyo en el análisis de la causa del accidente si el Cliente reporta un accidente grave del Vehículo.',
    bindingText15:
      '1.3.1.\tEn caso de un accidente grave del Vehículo, como cuando el Vehículo vuelca o vuelca sobre un costado mientras conduce, CFMOTO ayudará al Cliente, previa solicitud, a aclarar si el accidente se debe a un defecto en el Vehículo u otras circunstancias. La solicitud debe ser enviada a CFMOTO por el Cliente a través del distribuidor local / socio de ventas indicado en el Acuerdo de Venta de Vehículos.',
    bindingText16: '1.3.2.\tEn la medida en que los datos disponibles lo permitan, CFMOTO evaluará los datos en relación con la causa del accidente y entregará al Cliente el informe correspondiente.',
    bindingText17: '1.4.\tAsistencia al Cliente para recuperar el Vehículo después de la pérdida del Vehículo .',
    bindingText18:
      '1.4.1.\tSi se pierde el Vehículo, CFMOTO proporcionará al Cliente los datos de ubicación del Vehículo y otros datos útiles sobre el estado del Vehículo (como la ubicación de la última activación, el estado actual del vehículo, etc.) previa solicitud y si están disponibles.',
    bindingText19: '1.4.2.\tLa solicitud debe ser enviada a CFMOTO por el Cliente a través del distribuidor local / socio de ventas indicado en el Acuerdo de Venta de Vehículos.',
    bindingText2:
      'CFMOTO Powersports, Inc. (en adelante, " CFMOTO " ) proporciona servicios telemáticos para vehículos al cliente que compró el vehículo CFMOTO (en adelante, "Cliente" ). Para estos servicios, CFMOTO utiliza datos registrados por el Vehículo sobre el Vehículo y su comportamiento de conducción en el período de tiempo correspondiente. En detalle, esto se refiere a los siguientes datos:',
    bindingText20: '1.5.\tReporte de problemas post-venta .',
    bindingText21:
      '1.5.1.\tCFMOTO recopila de forma remota las notificaciones de códigos de error enviadas por el Vehículo en caso de mal funcionamiento de sus componentes y proporciona la información respectiva a pedido del Cliente directamente al Cliente.',
    bindingText22: '1.5.2.\tLa solicitud debe ser enviada a CFMOTO por el Cliente a través del distribuidor local / socio de ventas indicado en el Acuerdo de Venta de Vehículos.',
    bindingText23: '2.\tRestricciones y Exclusiones del Servicio',
    bindingText24:
      '2.1.\tSe señala expresamente que los cambios estructurales u otros técnicos en el Vehículo pueden limitar la prestación de los servicios o incluso imposibilitarla, ya que los servicios dependen de la correcta provisión de los datos del vehículo.',
    bindingText25: '2.2.\tCuando dichos servicios no puedan prestarse debido al rendimiento de redes de datos o telecomunicaciones de terceros , se excluye cualquier responsabilidad de CFMOTO.',
    bindingText26: '3.\tPrivacidad',
    bindingText27:
      'CFMOTO cumplirá con las normas de protección de datos aplicables al procesar datos personales en relación con el vehículo CFMOTO . Los términos de la política de privacidad de C FMOTO se establecen en esta APLICACIÓN CFMOTO RIDE . Como complemento a la política de privacidad , este aviso cumple con la política de privacidad . Y el Cliente puede consultar la política de privacidad para algunos contenidos relacionados con el procesamiento de datos no cubiertos por este aviso.',
    bindingText28: '4.\tServicio al Cliente',
    bindingText29:
      '4.1.\tEl Cliente puede enviar preguntas, comentarios o inquietudes relacionadas con la privacidad a CFMOTORIDEAPP@cfmotousa.com o escribir a: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. El Cliente también puede llamar Atención al cliente de CFMOTO al (888) 823-6686.',
    bindingText3: 'Datos de comportamiento de conducción del usuario : incluida la aceleración, desaceleración, velocidad, curvas, último tiempo de conducción y último kilometraje de conducción .',
    bindingText30: '5.\tR evisiones',
    bindingText31: '5.1.\tCFMOTO se reserva el derecho de cambiar este aviso en cualquier momento, pero publicaremos revisiones en CFMOTO RIDE App y/o avisar antes de que lo hagamos, según corresponda.',
    bindingText4:
      'Datos de estado del vehículo: se refiere al estado en tiempo real del vehículo, incluido el modo de conducción, el combustible residual, el ahorro instantáneo de combustible, el kilometraje, la marcha en tiempo real del vehículo, la velocidad del motor, la presión de los neumáticos, la temperatura de los neumáticos, los datos de voltaje de activación de la batería , temperatura del refrigerante, estado de la cerradura electrónica, versión del software del dispositivo inteligente, intensidad de la señal de los dispositivos inteligentes, configuración actual del tablero.',
    bindingText5:
      'Datos de alarma del vehículo: datos de alarma que se enviarán si ciertos datos exceden un valor preestablecido, como temperatura del motor, velocidad excesiva, tiempo de conducción excesivo, temperatura alta del refrigerante, movimiento anormal del vehículo, presión anormal de los neumáticos, vibración, descarga, colisión , etc. .',
    bindingText6: 'Información de Falla del Vehículo: se refiere a los códigos de falla reportados por cada parte interna del Vehículo.',
    bindingText7: 'Datos de Ubicación del Vehículo: se refiere al paradero geográfico específico del Vehículo.',
    bindingText8: '1.1.\tproporcionando _ el Cliente con servicios relacionados con el vehículo a través de la APLICACIÓN CFMOTO RIDE .',
    bindingText9: '1.1.1.\tAPLICACIÓN CFMOTO RIDE (incluida la visualización de la ubicación del vehículo, la configuración de la información y las funciones del vehículo, el control remoto del estado del vehículo, etc.).',
    bindingUser: 'Vincular usuario',
    bothServices: 'Ambos servicios',
    bound: 'Vinculado',
    businessType: 'Tipo de negocio',
    button: 'Botón',
    callbackedApply: 'Ha retirado su solicitud de eliminación de cuenta el yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Su solicitud de eliminación de cuenta se envió el aaaa-MM-dd HH:mm:ss.  Eliminaremos definitivamente su cuenta y los datos relacionados en los 15 días después de recibir la solicitud.  Después de la eliminación, ya no podrá utilizar el servicio CFMOTO RIDESYNC.  Para cancelar su solicitud de eliminación de cuenta, vuelve a visitar la página web o inicie sesión en la APP en los 15 días para retirar la solicitud de eliminación de cuenta.',
    callbackedApplyTip:
      'Su solicitud de eliminación de cuenta se envió el aaaa-MM-dd HH:mm:ss.  Eliminaremos definitivamente su cuenta y los datos relacionados en los 15 días después de recibir la solicitud.  Después de la eliminación, ya no podrá utilizar el servicio CFMOTO RIDE.  Para cancelar su solicitud de eliminación de cuenta, vuelve a visitar la página web o inicie sesión en la APP en los 15 días para retirar la solicitud de eliminación de cuenta.',
    canadaPrivacyPolicy: 'Política de privacidad de Canadá',
    canadaTelematicsPolicy: 'Acuerdo telemático de Canadá',
    canadaUserPolicy: 'Acuerdo de usuario canadiense',
    canadianAgreementText: 'Texto del Acuerdo Canadiense',
    cancel: 'Cancelar',
    cancellationAgreement: 'Acuerdo de cancelación',
    cancelled: 'Cancelada',
    carOwner: 'Dueño',
    carUserScore: 'Calificaciones de propietarios de vehículos',
    cardPass: '¡Verificación de identidad exitosa!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Cambiar a la autenticación con código de verificación',
    changeDescriptionType: 'Cambiar descripción',
    changeDescriptionTypeSelectNo: 'No implica cambios en la normativa de tratamiento de información personal',
    changeDescriptionTypeSelectYes: 'Cambios en las regulaciones que involucran el procesamiento de información personal',
    changeEmail: 'Modificar correo electrónico',
    changeEmailInfo: 'Cambiar a correo electrónico',
    changeFail: 'La modificación del estado falló',
    changeOne: 'Cambiar',
    changePassValidate: 'Cambiar a la autenticación con contraseña',
    changePasswordFailed: 'Error al cambiar la contraseña',
    changePasswordSuccessful: 'Cambio correcto de contraseña',
    changePhoneInfo: 'Cambiar al número de teléfono',
    changeStore: 'Cambiar tienda',
    changeSuccess: 'Estado modificado exitosamente',
    channelType: 'Canal de retroalimentación',
    characterLimitExceeded: 'Límite de caracteres superado',
    checkConfigurationTwo: 'El chino o el inglés %s no están completamente configurados, por favor, verifique.',
    checkCopyWriting: 'El contenido en chino o inglés no está completo, verifique.',
    checkEmpty: '%s está vacío, por favor, verifique.',
    checkEmptyEnglish: 'Inglés incompleto. Por favor, verifique',
    checkTriggerType: 'Hay una condición del mecanismo de activación que no se ha completado, verifique.',
    checkUpdate: 'verificar actualizaciones',
    cityFilter: 'Filtro de ciudad',
    clickImmediateFeedback: 'Haga clic para dar su opinión ahora',
    clickNumber: 'El número de clics',
    clickNumberDescription: 'Número de notificaciones en las que han hecho clic los usuarios',
    clickNumberVolume: 'Número de clics',
    clickToFeedback: 'Haga clic en los comentarios',
    clicks: 'Clics',
    closeNum: 'Cierre',
    closeTask: 'Tarea cancelada',
    code: 'Código de verificación',
    colorPicture: 'Imagen del bloque de color',
    comment: 'Comentario',
    commentContent: 'Comentarios',
    commentList: 'Lista de comentarios',
    commentNumber: 'Número de comentarios',
    commentTime: 'Tiempo de comentario',
    communication: 'en comunicación',
    community: 'Comunidad',
    communityManagement: 'Gestión comunitaria',
    communityRule: 'Norma comunitaria',
    completePuzzle: 'Por favor, completa el rompecabezas',
    completed: 'Terminado',
    condition: 'Condición',
    configureLanguage: 'Configurar idioma',
    configurePicture: 'Configurar imagen',
    confirm: 'Confirmar',
    confirmDeletePictures: 'Confirmar para eliminar esta imagen',
    confirmRedeem: 'Confirmar para canjear',
    confirmReviewNoPass: 'Confirmar para no pasar la revisión',
    confirmReviewPass: 'Confirmar para aprobar la revisión',
    consultDealer: 'Consulte a su concesionario local',
    contact: 'Su solicitud de eliminación de cuenta ha sido rechazada. Si tiene alguna pregunta, comuníquese con appsupport@cfmotousa.com para realizar una consulta.',
    contactMail: 'Correo electrónico',
    contactMethod: 'Contacto',
    contactUs: 'Contáctenos',
    content: 'Contenido',
    contentType: 'Tipo de contenido',
    copyFail: 'Copia fallida',
    copyLink: 'Copiar link',
    copySuccess: 'Copiado con éxito',
    copyWriting: 'Contenido emergente',
    country: 'País/región',
    countryCode: 'Código de país',
    countryName: 'País',
    countryNumber: 'Código de país',
    countryRegion: 'País/región',
    create: 'Nueva adición',
    createBy: 'Creador',
    createStore: 'Crear tienda',
    createTime: 'Tiempo de creación',
    cs_CZ: 'Checo',
    currency: 'Moneda',
    currentConfig: 'Configuración actual',
    currentCountryStoreTotal: 'Número total de tiendas en el país actual',
    currentRedemptionRatio: 'Ratio de canje actual',
    currentTime: 'Tiempo actual',
    customPage: 'Página personalizada',
    customSettings: 'Columnas personalizadas',
    dashcamHelp: 'Ayuda de Dashcam',
    dataDeletExplain: 'Guía de eliminación de datos',
    dataDelete: 'Eliminación de datos',
    dataDeleteApply: 'Solicitud de eliminación de datos',
    dataFormatError: 'Error de formato de datos',
    dataPermissionScope: 'Alcance del permiso de datos',
    dataType: 'Tipo de datos',
    dayOne: 'Días una vez',
    days: 'Día',
    daysAgo: 'Hace %s días',
    de_DE: 'Alemán',
    dealDate: 'Tiempo de procesamiento',
    dealerOperationList: 'Lista de operaciones del distribuidor',
    dealerOperationQuery: 'Consulta de operaciones de distribuidor',
    dealerOperationRecord: 'Registro de operaciones del concesionario',
    dealerStore: 'Tiendas distribuidoras',
    dealerStoreImportTempateName: 'Plantilla de importación de tienda de distribuidores',
    dealerStoreQuery: 'Consulta de las tiendas distribuidoras',
    dealers: 'Importador',
    default: 'Predeterminado',
    defaultMap: 'Mapa predeterminado',
    delete: 'Eliminar',
    deleteAccountSYNCStep: 'Puede seguir estos pasos para solicitar la eliminación de su cuenta CFMOTO RIDESYNC',
    deleteAccountStep: 'Puede seguir estos pasos para solicitar la eliminación de su cuenta CFMOTO RIDE',
    deleteDataSYNCStep: 'Puede seguir estos pasos para solicitar la eliminación de sus datos CFMOTO RIDESYNC',
    deleteDataStep: 'Puede seguir estos pasos para solicitar la eliminación de sus datos CFMOTO RIDE',
    deleteFail: 'Error al borrar',
    deleteFinish: 'Eliminación completada',
    deleteKolUserAuthentication: 'Eliminar autenticación de usuario KOL',
    deleteStore: 'Eliminar tienda',
    deleteSuccess: 'Eliminación correcta',
    deleteTip: '¿Seguro que quieres eliminar esta publicación? Una vez eliminada, la información no se puede recuperar',
    deleteVersionWarn: 'Si se debe eliminar este registro de versión',
    deleteVideo: '¿Eliminar este vídeo?',
    detailAddress: 'Dirección detallada',
    details: 'Detalles',
    determine: 'Claro',
    deviceCodeGet: 'Obtener código de dispositivo:',
    deviceContent:
      'El código del equipo del receptor de cerca electrónica (denominado: llave) es una cadena de códigos de 10 dígitos. El código del equipo, el código QR y la marca CE están impresos en la pegatina autoadhesiva de PVC plateada. Hay tres etiquetas en total, una está pegada a la carrocería del vehículo (es necesario levantar el cojín del asiento para verla); los otros dos se colocan en la bolsa de accesorios del vehículo. Se recomienda que los usuarios peguen la etiqueta en el manual del vehículo o en el control remoto.',
    deviceNo: 'Número de dispositivo asociado',
    deviceNumber: 'Número de dispositivo',
    deviceTitle: 'Comprobación de código',
    digitalKey: 'Clave digital',
    digitalKeyDesc: 'No es necesario llevar una llave física, admite el desbloqueo del vehículo después de conectarse a través de la aplicación Bluetooth (compatible con algunos modelos)',
    directRelease: 'Publicación directa',
    disagree: 'En desacuerdo',
    displayNumberDescription: 'Número de notificaciones mostradas en dispositivos',
    displayNumberVolume: 'Número de exposiciones',
    displayOrder: 'Orden de visualización',
    displayPicture: 'Diagrama de presentación',
    donwloadTemplateDescription: 'Primero descargue la plantilla, complétela (el contenido solo admite formato de texto) y luego cargue el archivo; el tamaño del archivo está limitado a 2M. Si el envío falla, reduzca el contenido de forma adecuada.',
    download: 'Descargar',
    downloadFailFile: 'Descargar archivo fallido',
    downloadSuccessful: 'Descarga exitosa',
    downloadTemplate: 'Descargar plantilla',
    downloading: 'Descargando...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'Editar',
    editAccountDeletExplain: 'Editar cuenta Notificación de eliminación',
    editActivity: 'Editar actividad',
    editAppRating: 'Editar mecanismo de calificación',
    editBanner: 'Editar Banner',
    editCanadaPrivacyPolicy: 'Editar la política de privacidad de Canadá',
    editCanadaTelematicsPolicy: 'Editar el Acuerdo Telemático de Canadá',
    editCanadaUserPolicy: 'Editar el Acuerdo de usuario de Canadá',
    editDashcamHelp: 'Editar ayuda de Dashcam',
    editDataDeletExplain: 'Editar aviso de eliminación de datos',
    editExhibitionCategory: 'Editar Categoría de Tienda',
    editExhibitionSeries: 'Editar Serie',
    editFunctionIntro: 'Introducción a la función de edición',
    editHelpConfiguration: 'Editar ayuda instrucciones configuración',
    editInformation: 'Editar informacion',
    editInformationCategory: 'Editar categoría de información',
    editInformationContent: 'Editar contenido de información',
    editKolUserAuthentication: 'Editar autenticación de usuario KOL',
    editModelSeries: 'Editar serie de modelos',
    editPicture: 'Editar foto',
    editPushConfiguration: 'Editar configuración de push',
    editRemark: 'Editar Notas',
    editServiceIntroduce: 'Introducción al servicio editorial',
    editShowroomModel: 'Edición de modelos de sala de exposiciones',
    editSuccess: 'Editado con éxito',
    editTime: 'Editar hora',
    editUnbindingCommitment: 'Editar compromiso de aplicación no vinculante',
    editUser: 'Editar usuario',
    editVehicleModel: 'Editar modelo',
    editVehicleModelCategory: 'Editar la categoría del modelo',
    effecting: 'Activación pendiente',
    effectiveTime: 'Fecha efectiva',
    electricVehicle: 'Vehículo eléctrico',
    email: 'E-mail',
    emailAdress: 'Dirección de correo electrónico',
    emailAdressTip: 'Nota: Esta dirección de correo electrónico se utiliza para el contacto con el cliente mediante correo electrónico. Asegúrese de que la dirección de correo electrónico sea correcta.',
    emailBindingFailed: 'Error de bloqueo de correo',
    emailContent: 'Contenido del correo electrónico',
    emailImportTemplate: 'Plantilla de importación de direcciones de correo electrónico',
    emailImportTemplateToDownLoad: 'Las direcciones de correo electrónico se pueden importar en lotes, haga clic para descargar.',
    emailList: 'Lista de correo',
    emailManage: 'Gestión de correo electrónico',
    emailMass: 'Explosión de correo electrónico',
    emailSearch: 'Consulta por correo electrónico',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'Correo electrónico',
    emailTitle: 'Sujeto',
    en_US: 'Inglés',
    enableStatus: 'Estado habilitado',
    enabled: 'Permitir',
    endTime: 'Hora de finalización',
    endTimeLargeStartTime: 'La hora de finalización debe ser posterior a la hora de inicio',
    enterAnswer: 'Por favor, introduzca la respuesta',
    enterCategory: 'Por favor, introduzca la categoría',
    enterCodeToSafeAccount: 'Para garantizar la seguridad de su cuenta, rellene la información de la cuenta que desea eliminar, e introduzca su contraseña o un código de verificación para autenticar su identidad.',
    enterCodeToSafeData: 'Para garantizar la seguridad de sus datos, rellene la información de su cuenta, e introduzca su contraseña o un código de verificación para autenticar su identidad.',
    enterIntroduceText: 'Por favor, introduzca un texto introductorio',
    enterLink: 'Por favor, ingrese la dirección del enlace',
    enterPopupTitle: 'Por favor, ingrese el título de la ventana emergente',
    enterQueryConditionLookData: 'Después de ingresar las condiciones de consulta, puede ver los datos',
    enterQuestion: 'Por favor, ingresa una pregunta',
    enterQuestionAndAnswer: 'Se requieren preguntas y respuestas en chino e inglés',
    enterSureUrl: 'Por favor, ingrese la URL correcta (la URL debe comenzar con "http" o "https")',
    enterTypeOfLanguage: 'Se deben completar las categorías de chino e inglés',
    enterUnbindingCommitment: 'Por favor, introduzca una carta de compromiso para la solicitud de desvinculación',
    entrance: {},
    errorLatAndLon: 'La latitud y la longitud tienen un formato incorrecto, compruébelo.',
    errorLocation: 'Error de ubicación',
    es_ES: 'Español',
    estimatedTime: 'Hora prevista',
    everySet: 'Por configuración',
    examineResultMessage: 'Verificaremos los materiales de la aplicación lo antes posible, preste atención a la barra de notificaciones o al centro de mensajes de la aplicación a tiempo.',
    example: 'Precedente',
    exchange: 'Canjear ahora',
    exchangeDescription1:
      'Estimado propietario de CFMOTO, su vehículo ha sido vinculado con éxito. Ha recibido una prueba gratuita de 1 año de servicios inteligentes. \nPor favor, elija los servicios que desea activar: \n- Edición Estándar \n- MotoPlay Premium \nPor favor, lea y acepte los términos \nVer "Acuerdo de servicio inteligente" \n[Confirmar]\t',
    exchangeDescription2:
      'Por favor, consulte el manual electrónico para todos los detalles del vehículo. También disfrutará de un periodo de prueba gratuito de 1 año para todos los servicios inteligentes CFMOTO RIDE, comenzando desde su fecha de vinculación inicial. \n[Cerrar] [Entendido]',
    exchangeDescription3:
      'Tiene XXX km de kilometraje disponible. Canjee ahora para seguir disfrutando del servicio inteligente CFMOTO RIDE. Si no toma ninguna acción, sus datos de kilometraje se conservarán durante 30 días después de desvincular la cuenta. El kilometraje no canjeado se borrará automáticamente y no podrá recuperarse después de este periodo. \n¿Está seguro de que desea canjear ahora? \n[Sí] [No] \n\n*Los beneficios del kilometraje canjeado se transferirán con el vehículo para el próximo propietario.',
    exchangeDescription4: 'Tiene XXX km de kilometraje disponible. ¿Quiere canjear su kilometraje para seguir \ndisfrutando del servicio inteligente CFMOTO RIDE gratis? \n[Sí] [No]',
    exchangeDescription5:
      'Recordatorio de servicio inteligente \nEstimado propietario de CFMOTO: Quedan XXX días en su experiencia gratuita del servicio inteligente de CFMOTO. Si activa el servicio inteligente, se activará dentro de 24 horas. Por favor, revise. \n[Confirmar]',
    exchangeDescription6: 'Disfrute de una mejor experiencia de ruta con MotoPlay, que ofrece servicios de duplicación de pantalla y navegación impulsados por Google Maps',
    exchangeRecords: 'Registro de canje',
    exchangeServiceTime: 'Tiene kilometraje disponible para canjear horas de servicio',
    exchangeSuccess: 'Canje exitoso',
    exhibition: 'Gestión de Tiendas',
    exhibitionCategory: 'Categoría de Tienda',
    exhibitionCategoryList: 'Lista de Categorías de Tienda',
    exhibitionCategorySearch: 'Consulta de Categoría de Tienda',
    exhibitionSeries: 'Series de Tiendas',
    exhibitionSeriesList: 'Lista de Series de Tienda',
    exhibitionSeriesSearch: 'Consulta de Serie de Tienda',
    exportContent: 'Exportar contenido',
    exportExcel: 'Exportar a EXCEL',
    exportLengthExceedOfMonth: 'La duración de la exportación no excederá de %s meses',
    externalLink: 'Enlace externo',
    failed: 'Error',
    failedToPreview: 'Revisión fallida',
    feedBackResut: 'Resultados',
    feedBackTime: 'Tiempo de respuesta',
    feedBackVechle: 'Vehículo',
    feedbackAppQuestion: 'Por favor, describa detalladamente la hora de ocurrencia, la versión de la APP, el modelo de teléfono móvil, la ruta de funcionamiento y la descripción del problema para ayudar a localizar y solucionar rápidamente el problema.',
    feedbackDetails: 'Detalles de la opinión',
    feedbackGuideDesc: 'Para obtener más información, comuníquese con nosotros a través del canal de comentarios a continuación.',
    feedbackLabelFileList: 'Por favor, suba una foto',
    feedbackMapQuestion:
      'Si encuentra que la dirección o la información de la calle que se muestra en el mapa de la aplicación no coincide con la situación real, proporcione su área, la información de la dirección (o calle) del problema actual y la información real de la carretera. Cuanto más detallada sea la descripción del problema, más fácil nos resultará solucionarlo y actualizar con precisión los datos del mapa.',
    feedbackMessageSubmitError: 'Fallo de retroalimentación',
    feedbackOtherQuestion: 'Por favor, describa cuándo ocurrió, cómo ocurrió y el problema',
    feedbackReceived: 'Feedback recibido',
    feedbackRecord: 'Registro de comentarios',
    feedbackRulesFileListMaxSize: 'Archivo de carga demasiado grande',
    feedbackRulesFileListOverType: 'Formato no soportado',
    feedbackSubmitTip: 'Si tienes alguna duda o comentario, también puedes contactar al Centro de Servicio al Cliente de CFMOTO México directamente vía WhatsApp (+52 18115286003) o correo electrónico (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Bienvenido a hacer valiosas sugerencias, consideraremos seriamente sus ideas',
    feedbackSupplement: 'Por favor agregue una descripción del problema',
    feedbackText: 'Comentarios',
    feedbackType: 'Tipo de respuesta',
    feedbackVehicleQuestion: 'Por favor, describa cuándo ocurrió, cómo ocurrió y el problema',
    female: 'Mujer',
    fileCountExceed: 'El número de archivos supera el límite',
    fileSizeExceed: 'El tamaño del archivo supera el límite',
    fileUploadingPleaceWait: 'Cargando archivos, espere, por favor',
    finalOperator: 'Operador definitivo',
    firstBindDate: 'Hora del primer vinculado del vehículo',
    firstMenu: 'Menú de nivel 1',
    forcedUpgrade: 'Actualización forzada',
    forgetPassword: 'Olvidé la contraseña',
    fourCarOfNumber: 'Número de usuarios de vehículos de cuatro ruedas',
    fourWheel: 'Vehículo de cuatro ruedas',
    fourWheelConfig: 'Configuración de la moto de cuatro ruedas para adultos',
    fourWheeler: 'Vehículo de cuatro ruedas',
    fourWheelerMostClicks: 'Modelos de cuatro ruedas con más clics',
    fourWheelowner: 'Propietarios de motos de cuatro ruedas para adultos',
    fr_FR: 'Francés',
    frankfurt: 'Fráncfort',
    freeLastDayBasedata: 'Duración gratuita de la edición estándar',
    freeLastDayMotoplay: 'Duración gratuita de MotoPlay',
    friday: 'Viernes',
    fuctionIntro: 'Introducción de funciones',
    fullscreen: 'Pantalla completa',
    funServiceIntro: 'Introducción a los servicios funcionales',
    function: 'Función',
    functionConfiguration: 'Configuración de funciones',
    functionConfigureTip: 'Esta función solo se aplica a los vehículos configurados a nombre del importador o usuarios en el país/región',
    functionDescription: 'Las funciones sólo están disponibles para los vehículos del nombre del importador configurado',
    functionDetail: 'Configuración (según el importador del vehículo)',
    functionIntroduce: 'Función descriptiva',
    functionSetting: 'Configuración de la función todoterreno del mapa',
    functionalOverview: 'Resumen de funciones',
    galleryEntrance: 'Entrada a la galería',
    galleryEntranceUploadRules: 'Requisitos de formato: jpg/jpeg/png, relación recomendada 4:3, tamaño no superior a 5 MB',
    gender: 'Sexo',
    generalAgreementText: 'Texto del Acuerdo General',
    generalAlarm: 'Alarma general',
    geofence: 'Cerco Elect.',
    getCarPosition: 'Obtenga la ubicación del vehículo a tiempo',
    getCode: 'Enviar',
    getExchangeRecordsError: 'Error al obtener los registros de canje',
    goCustomPage: 'Ir a la página personalizada',
    goOffline: 'Fuera de línea',
    goOnline: 'En línea',
    goUrlLink: 'Ir al enlace URL',
    groupTrail: 'Equipo todoterreno',
    groupTrailConfig: 'Configuración de la función todoterreno para equipos',
    guest: 'Sin coche',
    haveTwo: 'Ambos',
    havedWrite: 'rellenado',
    havedWriteAll: 'se han rellenado',
    havedWriteAllOrEmpty: 'se rellena o se vacía',
    helpAndFeedback: 'Ayuda y comentarios',
    helpCenter: 'Centro de ayuda',
    helpConfiguration: 'Ayuda para ilustrar la configuración',
    helpMessageHistoryDelete: '¿Eliminar todos los registros de búsqueda?',
    helpful: 'Útil',
    hint: 'Pista',
    historyDelete: '¿Eliminar todos los registros de búsqueda?',
    home: 'Pág. de inicio',
    homePage: 'Página de inicio personal',
    hour: 'Hora',
    hoursAgo: 'Hace %s horas',
    iWantEnableStoreUserQuery: 'Quiero activar la búsqueda de usuarios en la tienda',
    iWantToPostStatistics: 'Quiero publicar estadísticas',
    identification: 'Identificación',
    identificationText: 'Identificación',
    imageSizeExceed: 'Por favor, suba una imagen de %s de ancho y altura',
    imageUploadFailed: 'Error de subida de imagen',
    immediateRelease: 'Publicación inmediata',
    immediateSend: 'Enviar ahora',
    imporFailedOfTableHeader: 'Importación fallida. Cabecera de archivo no coincidente.',
    import: 'Importar',
    importDetails: 'Detalles de la pregunta',
    importExcel: 'Importar Excel',
    importFail: 'Fallo en la importación',
    importStatus: 'Estado de importación',
    importSuccessful: 'Importación exitosa',
    importTemplate: 'Descarga de plantillas',
    importer: 'importador',
    importerAccountOperationRecord: 'Registro de operaciones e inicio de sesión de la cuenta del importador',
    importerAvatar: 'Avatar del importador',
    importerDisplayName: 'Nombre del importador',
    importerEnquiry: 'Consulta del importador',
    importerManagement: 'Gestión del importador',
    importerOperationRecords: 'Registros de operaciones del importador',
    importing: 'Importando...',
    inProcess: 'contramedidas',
    inProgress: 'En curso',
    individualCenter: 'Centro individual',
    informationCategory: 'Categoría de información',
    informationCategoryList: 'Lista de categorías de información',
    informationCategoryQuery: 'Consulta de categoría de información',
    informationContent: 'Contenido de informacion',
    informationContentList: 'Lista de contenido de información',
    informationCotnentQuery: 'Consulta de contenido de información.',
    informationCover: 'Portada de la información',
    informationDetails: "Détails de l'information",
    informationImage: 'Imagen de portada',
    informationManagement: 'Gestión de la información',
    informationTitle: 'Título de la información',
    informer: 'Denunciador',
    informerId: 'ID del denunciador',
    initialPassword: 'Contraseña original',
    inputAgreementContent: 'Por favor, ingrese el contenido del acuerdo',
    inputCannotExceed20000: 'Ingrese hasta 20000 caracteres',
    inputErrorEmoji: 'Por favor, no introduzca emoticonos',
    installDeviceYouCan: 'La instalación de este dispositivo le permite',
    installVehicleModelAdd: 'Añadir descripción del modelo modificado',
    installVehicleModelDescription: 'Descripción del modelo modificado',
    installVehicleModelEdit: 'Editar instrucciones para modelos modificados',
    instrumentLastedVersion: 'Pantalla TFT no es necesario actualizarla',
    instrumentupgrade: 'Actualización de pantalla TFT',
    inteligentServiceReminder: 'Recordatorio de servicio inteligente',
    intelligentInternetServiceIntroduction: 'Introducción al servicio',
    intelligentServiceAgreement: 'Acuerdo de servicio inteligente',
    intelligentServices: 'Servicios inteligentes (detalles del vehículo, datos de viaje, OTA)',
    introText: 'Texto de introducción',
    introduction: 'Introducción',
    invalidVercode: 'código de verificación invalido',
    invoicePreview: 'Vista previa de la factura',
    invoicing: 'Facturación',
    invoicingFailed: 'Facturación fallida',
    invoicingSucceeded: 'Facturación exitosa',
    iovNotice1: 'Las funciones anteriores se basan en el dispositivo de red del vehículo (T-Box), consulte con el concesionario local para comprar e instalar.',
    iovNotice2: 'Las funciones anteriores son diferentes según la configuración de cada modelo y la región donde se encuentra. Consulte al concesionario local para obtener más detalles.',
    iovNotice3: 'Guarde y registre el número de dispositivo con anticipación, que se requiere al vincular el dispositivo. Después de completar la vinculación y la instalación, podrá experimentar más funciones.',
    isHelpful: '¿Es de ayuda?',
    isStop: '¿Parar?',
    isSupportedChildOwnerOffMapDown: '¿Apoya a los propietarios de motos no adultos a descargar mapas sin conexión?',
    isSupportedNoOwnerOffMapDown: 'Apoya a los que no son propietarios de motos a descargar mapas sin conexión?',
    isSupportedOffMapDown: '¿Admite la descarga de mapas sin conexión?',
    it_IT: 'Italiano',
    iterativeVehicleFunctions: 'Las partes principales del vehículo se pueden actualizar en línea de forma remota para repetir continuamente las funciones del vehículo.',
    jumpSettings: 'Configuración de salto',
    jumpTarget: 'Saltar objetivo',
    jumpToWeb: 'Explora más en nuestro sitio web',
    jumpUrl: 'Enlace de Redirección',
    justNow: 'Justo ahora',
    keySharing: 'Llave digital y uso compartido de llave',
    kolUser: 'Usuario KOL',
    kolUserList: 'Lista de usuarios KOL',
    kolUserManagement: 'Gestión de usuarios KOL',
    kolUserQuery: 'Consulta de usuarios KOL',
    language: 'Idioma',
    language1: 'Idioma asociado',
    languages: 'Idioma',
    lastLoginTime: 'Última hora de conexión',
    lastModifiedBy: 'Última modificación por',
    lastUpdateTime: 'Tiempo de última actualización',
    latitude: 'Longitud',
    launchActivity: 'Lanzar actividad',
    likeNumber: 'Número de "me gusta"',
    linkAddress: 'Dirección del enlace',
    linkUrlDescription: 'La URL debe comenzar con "http" o "https"',
    linkedOrder: 'Pedido vinculado',
    listDisplayImages: 'Visualización de lista',
    listOfImporters: 'Lista de importadores',
    listOfQuestion: 'Lista de preguntas',
    listShowStoreCoverPic: 'Mostrar imagen de portada de la tienda',
    loadMore: 'Cargar más',
    loadSuccess: 'Carga completa',
    loading: 'Cargado',
    locationFail: 'Posicionamiento fallido',
    log: 'Registro',
    login: 'Iniciar sesión',
    loginCountry: 'Iniciar sesión país/región',
    loginSuccessfully: 'Inicio de sesión correcto',
    logout: 'Salir del Estado de inicio de sesión',
    longitude: 'Longitudes',
    loosing: 'Datos refrescantes...',
    lowCompatibleVersion: 'Versión mínima compatible',
    mail: 'Correo electrónico',
    male: 'Hombre',
    manualReviewStatus: 'Estado de revisión manual',
    mapManage: 'Gestión de mapas',
    marketDataOfdealerStores: 'Datos de mercado de las tiendas de concesionarios',
    masteringCyclingData: 'Datos maestros de conducción',
    maximum: 'Máx.',
    maximumBannerCountTip: 'Un máximo de %s banners pueden estar en línea al mismo tiempo. Por favor, elimine al menos uno primero.',
    maximumMileage: 'Kilometraje máximo canjeable',
    maximumValue: 'Máximo',
    menuFunctionName: 'Nombre de la fun. de menú',
    menuIcon: 'Icono de menú',
    messagePush: 'Notificación push',
    messagePushDeleteAsk: '¿Está seguro de borrar este push?',
    messagePushDownloadTemplate: 'Descargue primero la plantilla y cárguela después de rellenar el archivo de la plantilla. El tamaño del archivo está limitado a 2 MB. Si el envío falla, reduzca el contenido adecuadamente.',
    messageWithdrawAsk: '¿Quiere retirar este push?',
    middle: 'Medio',
    min: 'Min',
    minAgo: 'Hace %s mins',
    minimum: 'Mín.',
    minimumValue: 'Mínimo',
    modelDetail: 'Detalles del modelo',
    modifyFail: 'Error de modificación',
    modifyPassword: 'Modf. la contraseña',
    modifySuccess: 'Modificación correcta',
    monday: 'Lunes',
    more4pic1video: 'Máximo 4 imágenes / 1 vídeo',
    moreDetailsConsultDealerStore: 'Para más detalles, por favor consulte su tienda de concesionarios',
    morning: 'Mañana',
    motoPlay: 'MotoPlay (servicio de navegación y duplicación de pantalla basado en Google)',
    motoPlayAgreement: 'Estado del acuerdo MotoPlay',
    motoplatNavigationScreen: 'Duplicación de pantalla de navegación MotoPlay',
    motoplayServicePay: 'Pago de MotoPlay',
    motoplayServiceResetTimeRule: 'La hora de reinicio de MotoPlay no puede ser posterior a la hora actual',
    motorcycle: 'Motocicleta',
    moveDown: 'Mover hacia abajo',
    moveLongPressMap: 'Mover o mantener pulsado el mapa para seleccionar una ubicación',
    moveMapSelectPoint: 'Mueve el mapa para seleccionar una ubicación',
    moveTo: 'Mover a',
    moveToBottom: 'Mover a la parte inferior',
    moveToTop: 'Mover a la parte superior',
    moveToTopStatus: 'Mover a la parte superior',
    moveTop: 'Ajuste superior',
    moveUp: 'Mover hacia arriba',
    multimedia: 'Multimedia',
    mustInteger: 'Debe ser un entero positivo',
    mute1Day: 'Silenciar por 1 día',
    mute2Days: 'Silenciar por 2 días',
    mute30Days: 'Silenciar por 30 días',
    mute3Days: 'Silenciar por 3 días',
    mute7Days: 'Silenciar por 7 días',
    muting: 'Silencio',
    nameOfImporter: 'Nombre del importador',
    navigation: 'Navegación por mapa',
    nearLoginTime: 'Última hora de inicio de sesión',
    needPopup: 'Necesita ventana emergente',
    negativeNum: 'Mala reseña',
    networkException: 'Excepción de red',
    newAddFail: 'Error en la adición',
    newAddSuccess: 'Agregado exitosamente',
    newBanner: 'Nuevo Banner',
    newCancellationAgreement: 'Nuevo acuerdo de cancelación',
    newEmail: 'Nuevo correo electrónico',
    newEmailEqualsValidate: 'La nueva dirección de correo electrónico no puede ser igual que la dirección original',
    newFunctionIntro: 'Introducción a las nuevas funciones',
    newMenuFunction: 'Nueva fun. de menú',
    newModelSeries: 'Nueva serie de modelos',
    newPassword: 'Nueva contraseña',
    newPasswordNotEqual: 'La nueva contraseña ingresada dos veces es inconsistente, vuelva a ingresar',
    newQuestionType: 'Agregar nuevas categorías de preguntas',
    newStoreNumber: 'Número de nuevas tiendas',
    newTopic: 'Nuevo tema',
    newUnbindingCommitment: 'Nuevo formulario de compromiso de desvinculación',
    nextStep: 'Siguiente',
    nickName: 'Nombre',
    no: 'No',
    noContent: 'Sin contenido relacionado',
    noContent2: 'Sugerir cambiar palabras clave o',
    noData: 'Sin datos',
    noExchangeRecord: 'Aún no hay registro de canje',
    noFeedbackRecord: 'Por el momento no hay registros de comentarios',
    noJump: 'Sin salto',
    noLog: 'Sin registro',
    noMores: 'No más',
    noNeedPopup: 'No se requieren ventanas emergentes',
    noOkToFeedback: 'Sin resolver, necesito más ayuda',
    noOwnerScore: 'Calificaciones de no propietarios',
    noPass: 'Rechazar',
    noSendPeople: 'Sin remitente',
    noSortingPermission: 'Sin permiso de ordenación',
    noSupportMapDown: 'No se admite la descarga de mapas sin conexión',
    noThisPermission: 'Sin permiso para esta operación',
    noUserSelected: 'Ningún usuario seleccionado, no puede enviar',
    nofiledSeviceContent: 'La introducción del servicio no se completa',
    nonOwner: 'No propietario',
    nonVehicleOwnerCharged: 'Cargo para el propietario sin moto después del uso de prueba',
    none: 'Ninguno',
    normal: 'Normal',
    notAllowImageAndVideo: 'No se puede seleccionar el vídeo al seleccionar las imágenes',
    notAllowed: 'No permitido',
    notBeLessOrEqual: 'No será inferior o igual a',
    notDeleted: 'No registrado',
    notDistributedYet: 'No publicado',
    notEnabled: 'No disponible',
    notHelpful: 'No es útil',
    notLessThan: 'No debe ser inferior a',
    notRecommended: 'No recomendado',
    notReleasedYet: 'Aún no publicado',
    notStarted: 'No ha comenzado',
    'notSupportT-Box': 'Lo sentimos, su vehículo no es compatible con T-Box',
    notTop: 'No hasta la parte superior',
    notice: 'Aviso',
    noticeText1: 'Estimado usuario de CFMOTO,',
    noticeText2:
      '¡Hola!  Le agradecemos sinceramente su continuo apoyo y confianza en CFMOTO. Para mejorar continuamente su experiencia de servicio, nos comprometemos a aumentar la calidad del servicio y a implementar mejoras innovadoras. En este contexto, hemos realizado ajustes comerciales y por la presente le notificamos que a partir de 08/10/2024, suspenderemos la aplicación CFMOTO RIDE (la "aplicación") en los Estados Unidos. Con el fin de garantizar que su experiencia de servicio no se vea afectada, hemos lanzado una nueva aplicación CFMOTO RIDESYNC. Esperamos que puedan seguir disfrutando de nuestros nuevos servicios a través de esta nueva app.',
    noticeText3: 'Notas importantes:',
    noticeText4:
      '1. A partir de hoy, esta aplicación sólo estará disponible para los vehículos CFMOTO vinculados en los Estados Unidos y dejará de ser compatible con los vehículos nuevos vinculantes. Si desea vincular un vehículo nuevo, descargue y utilice la aplicación CFMOTO RIDESYNC.',
    noticeText5:
      '2. Le recomendamos encarecidamente que descargue y use la aplicación CFMOTO RIDESYNC antes de 08/10/2024 para que pueda continuar disfrutando de nuestros servicios sin problemas. Le ofrecemos un conveniente servicio de migración de datos. Puede optar por migrar todos los datos conservados en esta aplicación a la aplicación CFMOTO RIDESYNC para garantizar que su información personal, la información del vehículo y los registros de uso del servicio se conserven por completo. Garantizaremos la seguridad y privacidad de sus datos durante el proceso de migración. Si desea utilizar la aplicación CFMOTO RIDESYNC pero decide no migrar sus datos, puede registrarse de nuevo en la aplicación CFMOTO RIDESYNC para utilizar los nuevos servicios. Haga clic en el botón de abajo para aprender cómo descargar y utilizar la aplicación CFMOTO RIDESYNC.',
    noticeText6:
      '3. Tenga en cuenta que después de 08/10/2024, ya no podrá utilizar los servicios relevantes de la aplicación en los Estados Unidos.  Mientras tanto, eliminaremos todos los datos personales generados durante su uso de la aplicación de acuerdo con las leyes y normativas pertinentes.',
    noticeText7:
      'Somos plenamente conscientes de que este cambio puede causarle inconvenientes temporales, pero creemos que con esta actualización del servicio, tendrá una experiencia de uso más rica y satisfactoria. Si tiene algún problema o pregunta durante este proceso, siempre estaremos aquí para ayudarle. Gracias por su comprensión y cooperación, y esperamos servirle en la aplicación CFMOTO RIDESYNC.',
    noticeText8: '¡Le deseamos una vida feliz!',
    notzero: 'Los números de versión no pueden ser todos 0',
    obtainVerificationCode: 'Obtener el código de verificación',
    officiaAndKolList: 'Lista oficial/KOL',
    officialAccount: 'Cuenta oficial',
    officialAccountAuth: 'Autorización de cuenta oficial',
    officialIrKOLSearch: 'Búsqueda de Oficial/KOL',
    officialKolAuth: 'Autorización oficial/KOL',
    offline: 'Offline',
    offlineAlready: 'Fuera de línea',
    offlineTime: 'Tiempo fuera de línea',
    offlineTimeMustBeGreaterThan: 'El tiempo fuera de línea debe ser superior a',
    ok: 'OK',
    oldPassword: 'Contraseña antigua',
    onLineAlready: {},
    oneMonths: 'Un mes',
    oneYear: 'Un año',
    online: 'En línea',
    onlyFourWheel: 'Sólo cuatro ruedas',
    onlyTwoWheel: 'Sólo dos ruedas',
    openEveryCount: 'Abierto cada vez',
    openEveryDay: 'Abierto todos los dias',
    openProductType: 'Tipo de producto abierto',
    operationRecord: 'Registros de operaciones',
    operationTime: 'Tiempo de operación',
    operations: 'Operaciones',
    operator: 'Operador',
    operattor: 'Operador',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Actualización opcional',
    orderFeedBackNum: 'Número de comentarios de pedidos',
    orderList: 'Lista de pedidos',
    orderMange: 'Gestión de pedidos',
    orderNum: 'No. de pedidos',
    orderQuestion: 'Describa la fecha y los detalles del problema y suba una o más capturas de pantalla del problema. Para problemas de pago, suba también el comprobante de deducción',
    originalEmail: 'Correo electrónico original',
    otaUpgradeVehicle: 'Vehículo de actualización OTA',
    otaUpgradeVehicleDesc: 'Los componentes principales del vehículo se pueden actualizar de forma remota para iterar continuamente el rendimiento del vehículo.',
    other: 'Otros',
    over: 'Sobre',
    owner: 'Tener un coche',
    ownerIdHomepageImage: 'Página principal del carné de identidad, licencia de conducir o pasaporte que contiene información de identificación personal.',
    parameterConfiguration: 'Configuración de parámetros',
    partialImportFailed: 'Fallo en la importación parcial',
    pass: 'Aprobar',
    passValidateDeleteAccount: '¡Verificación de identidad exitosa! Haga clic en el botón Enviar Solicitud en la parte inferior para solicitar la eliminación de la cuenta.',
    password: 'Contraseña',
    passwordRuleText: '8-20 caracteres, debe contener letras en inglés mayúsculas y minúsculas, números, caracteres especiales',
    passwordRules: 'Reglas de contraseña',
    paySetting: 'Gestión de la carga de mapas',
    payStrategy: 'Estrategia de pago',
    paymentLastDayBasedata: 'Duración de pago de la edición estándar',
    paymentLastDayMotoplay: 'Duración de pago de MotoPlay',
    peleaseEnterProvince: 'Por favor, introduzca una provincia/estado',
    pendSend: 'Pendiente',
    pending: 'Pendiente',
    pendingSubmit: 'Envío pendiente',
    permanentMuting: 'Silenciado permanente',
    phoneModel: 'Modelo',
    phoneNum: 'Número de teléfono',
    phoneNumber: 'Número de teléfono',
    phoneOrEmail: 'Número de teléfono/E-mail',
    phoneOrEmailImportTemplate: 'Plantilla de importación de números de teléfono móvil y direcciones de correo electrónico',
    phoneOrEmailNotRegistered: 'Este número de teléfono móvil o dirección de correo electrónico no está registrado',
    phoneOrEmailOrUserId: 'Número de teléfono móvil/correo electrónico/ID de usuario',
    picture: 'Imagen',
    pl_PL: 'Polaco',
    pleaseAddImage: 'Por favor, añada archivos de imagen',
    pleaseAddVideoFile: 'Por favor, añada archivos de vídeo',
    pleaseEnter: 'Por favor, ingrese',
    pleaseEnterAccountInfo: 'Por favor, ingrese la información de la cuenta',
    pleaseEnterAmount: 'Introduzca el importe',
    pleaseEnterCity: 'Por favor, introduzca una ciudad',
    pleaseEnterEmail: 'Por favor, introduzca su dirección de correo electrónico',
    pleaseEnterEmailAdress: 'Introduzca la dirección de correo electrónico',
    pleaseEnterIntro: 'Por favor, ingrese la introducción',
    pleaseEnterLatAndLong: 'Por favor, introduzca la latitud y longitud',
    pleaseEnterNewPassword: 'Introduzca la nueva contraseña',
    pleaseEnterPassword: 'Ingrese la contraseña',
    pleaseEnterPhone: 'Por favor, introduzca su número de teléfono',
    pleaseEnterQuestionDescription: 'Por favor, introduzca una descripción de su problema',
    pleaseEnterRealname: 'Por favor, ingrese su nombre real',
    pleaseEnterRemark: 'Por favor, ingrese comentarios',
    pleaseEnterServePhone: 'Por favor, introduzca un número de teléfono de servicio',
    pleaseEnterStoreAddressDetail: 'Por favor, introduzca la dirección detallada',
    pleaseEnterStoreIntroduce: 'Por favor, introduzca la introducción de la tienda',
    pleaseEnterStoreName: 'Por favor, introduzca el nombre de tienda',
    pleaseEnterStoreRemarkName: 'Por favor, introduzca el apodo de tienda',
    pleaseEnterTitle: 'Por favor, introduce un título',
    pleaseEnterUsername: 'Introduzca un nombre de usuario',
    pleaseEnterVercode: 'Ingrese el código de verificación',
    pleaseEnterVersion: 'Por favor, ingrese el número de versión',
    pleaseEnterVersionIntroduction: 'Por favor, ingrese la introducción de la versión',
    pleaseEnterVideoDetail: 'Por favor, ingresa los detalles del video',
    pleaseEnterVin: 'Por favor, ingrese el VIN',
    pleaseInputWord: 'Por favor, introduzca palabra clave',
    pleaseLoginFirst: 'Primero inicie sesión',
    pleaseRepeatNewPassword: 'por favor repita la nueva contraseña',
    pleaseSelect: 'Por favor, elija',
    pleaseSelectAuthAccount: 'Seleccionar cuenta autorizada',
    pleaseSelectBusinessHours: 'Por favor, seleccione el horario de apertura',
    pleaseSelectCity: 'Por favor, seleccione una ciudad',
    pleaseSelectCountry: 'Por favor, seleccione país',
    pleaseSelectCurrency: 'Seleccione una moneda',
    pleaseSelectMatchingMultimediaContent: 'Seleccione el contenido multimedia correspondiente',
    pleaseSelectPayChannel: 'Seleccione el canal de pago',
    pleaseSelectProblemWhere: 'Por favor, seleccione un escenario en el que se produce el problema',
    pleaseSelectProducType: 'Seleccione el tipo de producto',
    pleaseSelectProvince: 'Por favor, seleccione provincia/estado',
    pleaseSelectQueType: 'Por favor, seleccione el tipo de pregunta',
    pleaseSelectReportReason: 'Seleccione el motivo de la notificación',
    pleaseSelectService: 'Seleccione primero un servicio',
    pleaseSelectStatus: 'Seleccione el estado',
    pleaseSelectStoreType: 'Por favor, seleccione el tipo de tienda',
    pleaseSelectTimedSendTime: 'Por favor, seleccione la hora de envío',
    pleaseSelectUserTheList: 'Seleccione un usuario de la lista',
    pleaseSelectVehicle: 'Por favor, seleccione un vehículo',
    pleaseSelectVehicleConfig: 'Seleccione la configuración de la moto',
    pleaseSelectlinkedOrder: 'Por favor, selecciona un pedido vinculado.',
    pleaseSelectupgradeType: 'Por favor, seleccione el método de actualización',
    pleaseSureType2: 'Asegúrese de que ha introducido todos los datos',
    pleaseUpload: 'Por favor, suba',
    pleaseUploadPicVideo: 'Por favor, suba imágenes/vídeos',
    pleaseUserTimeFill: 'Rellene según la hora del usuario final',
    popUpFrequencyType: 'Formulario de ventana emergente',
    popUpFrequencyValue: 'Frecuencia emergente',
    popUpFrequencyValueValid: 'Por favor, seleccione los días de frecuencia',
    popUpReminder: 'Ya sea para mostrar un recordatorio',
    popupArea: 'Rango de usuarios emergentes',
    popupCreate: 'Agregar ventana emergente',
    popupDayOne: 'Una vez por número determinado de días',
    popupEdit: 'Editar ventana emergente',
    popupFrequency: 'Frecuencia emergente',
    popupManagement: 'Gestión de ventanas emergentes',
    popupOne: 'Juega solo una vez',
    popupPosition: 'Ubicación de la ventana emergente',
    popupStatus: 'Estado emergente',
    popupTarget: 'Objetivo emergente',
    popupTime: 'Tiempo emergente',
    popupTitle: 'Título de la ventana emergente',
    positiveNum: 'Buenas críticas',
    postComment: 'Comentario de publicación',
    postContent: 'Contenido de publicación',
    postId: 'ID de publicación',
    postList: 'Lista de publicaciones',
    postManagement: 'Gestión de publicaciones',
    postSearch: 'Búsqueda de publicación',
    posts: 'Publicaciones',
    precautionText1:
      '¡Hola! Como se enteró de que suspenderemos la aplicación CFMOTO RIDE (en adelante, "la Aplicación") en los Estados Unidos a partir de 08/10/2024, para ayudarle con este cambio, le rogamos que tome nota de las siguientes asuntos importantes:',
    precautionText2: '1. A partir de hoy, no podrá vincular un vehículo nuevo a través de la Aplicación para disfrutar de los servicios de vehículo relevantes.',
    precautionText3:
      '2. Para garantizar una transición fluida al nuevo servicio, hemos proporcionado una entrada en la parte superior de la página del vehículo en esta Aplicación. Puede aprender cómo descargar y utilizar la aplicación CFMOTO RIDESYNC en cualquier momento a través de esa entrada.',
    precautionText4:
      '3. Tenga en cuenta que una vez que el servicio deje de surtir efecto, ya no podrá disfrutar de ningún servicio de la Aplicación en los Estados Unidos. Al mismo tiempo, eliminaremos todos los datos personales generados durante su uso de la Aplicación de acuerdo con las leyes y normativas pertinentes. Esto significa que no podremos responder a ninguna de sus solicitudes de datos una vez suspendido el servicio.',
    precautionText5:
      'Entendemos que este cambio puede causarle inconvenientes, pero estamos comprometidos a proteger continuamente la seguridad y la privacidad de sus datos. Le recomendamos que tome medidas tempranas para descargar y comenzar a utilizar la aplicación CFMOTO RIDESYNC de manera oportuna para que pueda continuar disfrutando del servicio de calidad proporcionado por CFMOTO. Si tiene alguna pregunta o necesita asistencia en este proceso, no dude en contactarnos. Esperamos servirle en la aplicación CFMOTO RIDESYNC.',
    privacyContent: 'Detalles del contenido de la política de privacidad',
    privacyPolicy: 'Política de privacidad',
    privacyPopupAgree: 'Volver a obtener el consentimiento del usuario a la política de privacidad a través de una ventana emergente',
    privacyVersion: 'Versión de la política de privacidad',
    privacyVersionList: 'Lista de versiones de la política de privacidad',
    problemaDes: 'Descripción del problema',
    processMethod: 'Métodos de procesamiento',
    processReason: 'Motivo de procesamiento',
    processReasonDetails: 'Detalles del motivo de procesamiento',
    processRecord: 'Registro de procesamiento',
    processReport: 'Procesar denuncias',
    processSolution: 'Solución de procesamiento',
    processUser: 'Procesar al usuario',
    processed: 'Procesado',
    productDetails: 'Detalles de producto',
    productTime: 'tiempo de producción',
    prohibitDecimalsAndNegative: 'Prohibir la introducción de números decimales y negativos',
    pt_PT: 'Portugués',
    publishInformation: 'Publicar información',
    publishPosts: 'Publicar publicaciones',
    pullBefore: 'Tire hacia abajo para refrescar.',
    pulling: 'Liberar actualización ahora',
    purchaseAndInstall: 'Comprar e instalar',
    pushConfiguration: 'Configuración de push',
    pushContent: 'Enviar contenido',
    pushList: 'Lista de empuje',
    pushMode: 'Modo de empuje',
    pushNow: 'Empuje ahora',
    pushQuery: 'Consulta de empuje',
    pushRecord: 'Registro de empuje',
    pushScope: 'Alcance de empuje',
    pushTime: 'Tiempo de empuje',
    pushTimeDifferenceAsk: 'La hora de envío que elijas puede provocar que algunos usuarios no puedan recibir este envío debido a diferencias horarias. ¿Estás seguro de que quieres guardar?',
    pushTitle: 'Título de push',
    pushed: 'Empujado',
    pushing: 'Empujando',
    quantity: 'Cantidad',
    query: 'Buscar',
    question: 'Pregunta',
    questionInquiry: 'Consulta de preguntas',
    questionType: 'Tipo de pregunta',
    questionTypeList: 'Lista de clasificación de preguntas',
    questionTypeTemplate: 'Centro de ayuda: plantilla de clasificación de problemas',
    quickRelease: 'Publicación rápida',
    ranking: 'Clasificación',
    ratingWarn1:
      'Para los usuarios propietarios de vehículos, el control de servicio inteligente correspondiente al país/región en el fondo de administración no se ha activado o el servicio de servicio inteligente no ha caducado después de activarse. El vehículo está en línea y tiene',
    ratingWarn2: 'uno o más registros de conducción completos (el inicio y el final de cada viaje son eventos informados), aparecerá una ventana emergente cuando el usuario salga de My Cycling y regrese a la página de inicio.',
    reUpgrade: 'Reintentar',
    readAgree: 'Lea y acepte la',
    readAndAgree: 'Por favor, lea y acepte',
    readAndAgreeTo: 'He leído y acepto la',
    readDeleteStep: 'Comprender los tipos de datos que eliminaremos o conservaremos, así como los periodos de conservación adicionales.',
    realname: 'Nombre real',
    reasonForReport: 'Motivo',
    receiveCarReminderMessage: 'Recibir alertas de mensajes de vehículos',
    rechargeAmount: 'Importe de recarga',
    rechargeChannel: 'Canal de recarga',
    rechargeStatus: 'Estado de recarga',
    rechargeTime: 'Tiempo de recarga',
    recharged: 'Recargado',
    recipients: 'Recipiente',
    recipientsNum: 'Alcance del destinatario',
    recommended: 'Recomendado',
    recommendedStatus: 'Estado recomendado',
    redeemableServiceHours: 'Horas de servicio canjeables',
    redemptionMileage: 'Kilometraje disponible para canje',
    redemptionRatio: 'Ratio de canje',
    redemptionTime: 'Hora de canje',
    redirectUrl: 'URL de redirección',
    refreshInterval: 'Tiempo de actualización',
    refreshSend: 'Reenviar',
    refundFailed: 'Reembolso fallido',
    refunded: 'Reembolsado',
    refunding: 'Reembolso',
    refused: 'Rechazado',
    registerDate: 'Tiempo de inscripción',
    rejected: 'Rechazado',
    releaseContent: 'Publicar contenido',
    releaseMethod: 'Método de publicación',
    releaseMute: 'Liberar el silencio',
    releaseTime: 'Tiempo de liberación:',
    released: 'Publicado',
    releasedBy: 'Publicado por',
    remainServiceHavExpired: 'Tiempo restante hasta que expire el servicio inteligente',
    remainingAvailableMileage: 'Kilometraje disponible restante',
    remark: 'Notas',
    rememberPassword: 'Record. la contraseña',
    reminder: 'Recordatorio',
    remove: 'Eliminar',
    removeOnlinUpgrade: 'Vehículo de actualización en línea remoto',
    repeatNewPassword: 'Repetir la nueva contraseña',
    replaceTBOX: 'Sustituir TBOX',
    replied: 'Respondió',
    reply: 'Responder',
    report: 'Denunciar',
    reportList: 'Lista de informes',
    reportManagement: 'Gestión de denuncias',
    reportReason: 'Motivo de denuncia',
    reportReasonDetails: 'Detalles del motivo de denuncia',
    reportReasonPlaceholder: 'Escriba lo que quiere informar, 0-1500 palabras',
    reportSearch: 'Consulta de denuncias',
    reportSuccessful: 'Informe correctamente, nos ocuparemos de ello lo antes posible',
    reportTime: 'Tiempo de denuncia',
    reportType: 'Tipo de informe',
    reportedContent: 'Contenido denunciado',
    reportedUser: 'Usuario denunciado',
    reportedUserId: 'ID del usuario denunciado',
    requestTimedOut: 'Tiempo de espera agotado',
    resend: 'Reenviar',
    resendTo: 'Reenviar a',
    reset: 'Restablecer',
    resetItem: 'Ítem de reinicio',
    resetTime: 'Hora de reinicio del servicio inteligente',
    resetWarn: 'Después del reinicio, el período gratuito de los servicios inteligentes del vehículo se recalculará y entrará en vigor según la hora actual (hora del navegador). Por favor, confirme si desea reiniciar.',
    return: 'Devolver',
    review: 'Revisión',
    reviewApproved: 'Revisión aprobada',
    richText: 'Texto rico',
    ro_RO: 'Rumano',
    roleDescription: 'Descripción de rol',
    roleName: 'Nombre de rol ',
    rolePermission: 'Permiso de rol',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Ruso',
    safeRemind: 'Para proteger la seguridad de su cuenta, le rogamos que no envíe aquí información personal sensible, como contraseñas de cuentas, etc.',
    satelliteMap: 'Mapa satelital',
    saturday: 'Sábado',
    save: 'Guardar',
    saveAndPreview: 'Guardar y previsualizar',
    saveAsDraft: 'Guardar como borrador',
    saveFail: 'Error al guardar',
    savePicture: 'Guardar foto',
    saveSettings: 'Guardar ajustes',
    saveSuccess: 'Guardado con éxito',
    saveVideo: 'Guardar vídeo',
    scanQrcodePreview: 'Escanea el código QR a continuación con tu teléfono móvil para obtener una vista previa',
    screenNavigationGuidance: 'Ajustes instrucciones',
    sdkStatement: 'Declaración del SDK',
    search: 'Buscar',
    searchRecords: 'Historial de búsqueda',
    secondaryMenu: 'Menú secundario',
    securityMessage: 'La información anterior se utiliza únicamente para verificación de identidad. CFMOTO protege su información.',
    securityServices: 'Servicios de seguridad (posicionamiento en tiempo real, geocerca, alarma de malfunción)',
    select: 'Seleccionar',
    selectAccount: 'Seleccionar cuenta',
    selectAll: 'Seleccionar todo',
    selectAuthentication: 'Seleccionar autenticación',
    selectChannelType: 'Por favor, seleccione un canal de comentarios',
    selectCountry: 'Seleccionar país',
    selectData: 'Seleccione los datos que desea eliminar, y haga clic en el botón Enviar en la parte inferior para enviar su solicitud de eliminación de datos.',
    selectDate: 'Seleccione fecha',
    selectEnableStatus: 'Por favor, seleccione el estado habilitado',
    selectFeedBackState: 'Seleccionar el estado de procesamiento de comentarios',
    selectFeedbackType: 'Seleccione el tipo de pregunta',
    selectJumpTarget: 'Por favor, seleccione objetivo de salto',
    selectLanguage: 'Por favor, selecciona idioma',
    selectOneCarType: 'Seleccione al menos un modelo',
    selectPoint: 'Seleccione punto',
    selectPopupFrequency: 'Por favor, seleccione la frecuencia emergente',
    selectPopupPosition: 'Seleccione la ubicación de la ventana emergente',
    selectPopupTarget: 'Por favor, seleccione el destino emergente',
    selectPopupTime: 'Por favor, seleccione la hora de aparición',
    selectRejectReason: 'Por favor, seleccione un motivo de rechazo',
    selectTheLanguage: 'Elegir un idioma',
    selectTime: 'Seleccionar hora',
    selectUser: 'Seleccionar usuarios',
    selectVehicle: 'Seleccionar vehículo',
    selectedMileage: 'Kilometraje seleccionado',
    selectedMileageRedemption: 'Seleccione kilometraje para canjear',
    selectionOfImporter: 'Selección del importador',
    sendNumberDescription: 'Número de dispositivos válidos en los que AWS creó tareas de envío;',
    sendNumberDescription0: 'Entre los dispositivos de destino efectivos, el servidor Aurora crea realmente con éxito el número de dispositivos para enviar tareas',
    sendNumberVolume: 'Número de envíos',
    sendTo: 'Enviar a',
    sendType: 'Modo de envío',
    sendUserNum: 'Número de usuarios',
    sending: 'Enviando',
    serial: 'No.',
    seriesBackground: 'Imagen de Fondo de la Serie',
    seriesDesc: 'Descripción de la Serie',
    seriesIntroduction: 'Introducción a la serie',
    seriesName: 'Nombre de la Serie',
    seriesShowcase: 'Mapa de exhibición de la serie',
    seriesUplodImgRule: 'El formato de imagen requerido es jpg/jpeg/png con una relación recomendada de 9:16, resolución de 1080 o 1920x1080 píxeles, y un tamaño máximo de 5 MB.',
    seriousAlarm: 'Alarma grave',
    serviceDays: 'Días de servicio',
    serviceDetail: 'Detalles del servicio inteligente',
    serviceExpiration: 'Sus servicios inteligentes han expirado',
    serviceHavExpired: 'Servicios inteligentes caducados',
    serviceIntroduction: 'Introducción al servicio',
    serviceReset: 'Reinicio del Servicio Inteligente',
    serviceText: 'Servicio',
    settingSuccess: 'Fijado correctamente',
    shareNumber: 'Número de veces que se ha compartido',
    sheet: 'Hoja',
    show: 'Ver',
    showPicturesOfVideos: 'Mostrar imágenes/vídeos',
    showToast1: 'Kilometraje insuficiente para 1 día de servicio',
    showToast2: 'Se requiere al menos 1 día de servicio para el canje',
    showToast3: 'El parámetro no existe o está vacío',
    showroomModel: 'Modelo de sala de exposiciones',
    showroomModelList: 'Lista de modelos de sala de exposición',
    showroomModelQuery: 'Consulta de modelo de sala de exposición',
    showroomUploadRules: 'El requisito de formato de imagen es jpg/jpeg/png, la relación de imagen es 9:19.5, el tamaño no supera los 5 MB y el tamaño del vídeo no supera los 50 MB.',
    signOut: 'Terminación automática',
    singapore: 'Singapur',
    sixMonths: 'Seis meses',
    slideToRight: 'Desliza a la derecha',
    smartServices: 'Servicios inteligentes',
    someUser: 'Algunos usuarios',
    sort: 'Tipo',
    source: 'Origen',
    sr_YU: 'Serbio',
    standardAgreement: 'Estado del acuerdo Standard Edition',
    startCalculateTimeBasedata: 'Tiempo de reinicio de la edición estándar',
    startCalculateTimeMotoplay: 'Tiempo de reinicio de MotoPlay',
    startChecking: 'Inicio de la inspección',
    startTime: 'Hora de inicio',
    statisticalTime: 'Tiempo estadístico',
    status: 'Estado',
    stepText1: 'Para garantizar una migración de datos y un uso de la aplicación CFMOTO RIDESYNC sin problemas, le recomendamos que siga estos pasos:',
    stepText2: '1. Primero, haga clic en el botón de abajo [Descargar CFMOTO RIDESYNC] o abra directamente Apple Store/Google Play para buscar y descargar la aplicación CFMOTO RIDESYNC;',
    stepText3: '2. Después de descargar e instalar la aplicación CFMOTO RIDESYNC, ábrala para ingresar a la página de inicio de sesión. En esta página, debe iniciar sesión con su cuenta y contraseña CFMOTO RIDE existentes;',
    stepText4:
      '3. Después de introducir su cuenta y contraseña correctamente, aparecerá un cuadro de diálogo preguntándole si desea iniciar la migración de datos. Al hacer clic en OK, la migración de datos se inicia inmediatamente y este proceso no será interrumpido. Si selecciona "Cancelar" en este paso, no podrá seguir iniciando sesión en la aplicación.',
    stepText5: '4. Después de hacer clic en Aceptar, la migración de datos comenzará inmediatamente y el proceso será ininterrumpido. Si eso falla, comuníquese con appsupport@cfmotousa.com.',
    stepText6:
      '5. Una vez completada la migración de datos, entrará automáticamente en la página de inicio del vehículo de la aplicación CFMOTO RIDESYNC. En este momento, podrá empezar a utilizar todas las funciones de la aplicación con normalidad, y podrá acceder a todos los datos que haya conservado previamente en la aplicación CFMOTO RIDE.',
    stepText7:
      '*Notas importantes: Asegúrese de iniciar sesión en la aplicación CFMOTO RIDESYNC con su cuenta CFMOTO RIDE para garantizar una migración de datos exitosa. Si decide registrar una cuenta nueva o iniciar sesión con otra cuenta, sus datos no se migrarán. Además, una vez realizada la migración de datos, su cuenta CFMOTO RIDE original ya no le permitirá iniciar sesión en la aplicación CFMOTO RIDE. Por favor, opere con cuidado para garantizar la migración segura de sus datos.',
    stop: 'Detener',
    store: 'Almacenar',
    storeAddressCountryTip: 'Nota: Esta dirección de tienda es la única base para que los usuarios le encuentren. Por favor, rellene con cuidado para asegurarse de que la dirección sea correcta.',
    storeAddressDetail: 'Dirección de tienda',
    storeAddressDetailTip: 'Ejemplo: Dirección detallada: 813 Howard Street Oswego NY 13126 USA',
    storeAddressPosition: 'Latitud y longitud',
    storeAddressPositionTip:
      'Longitud: la parte entera de la longitud es un número entero comprendido entre -180 y 180, y la parte decimal es un decimal no superior a 15 cifras.\\nLatitud: la parte entera de la latitud es un número entero comprendido entre -90 y 90, y la parte decimal es un decimal no superior a 15 cifras.',
    storeBusinessType: 'Tipo de tienda',
    storeImage: 'Imagen de tienda',
    storeImportTemplateText: 'Descargue la plantilla, complete la información del distribuidor en el archivo de plantilla y luego cargue el archivo; el tamaño del archivo está limitado a 1 MB; si la carga falla, reduzca el contenido o cargue por lotes',
    storeIntroduce: 'Introducción de la tienda',
    storeList: 'Lista de tiendas',
    storeMange: 'Gestión de la tienda',
    storeName: 'Nombre de tienda',
    storeNameTip: 'Nota: Seleccione un idioma compatible con el sistema para rellenar el nombre de tienda',
    storeQueryUserStatistics: 'Estadísticas de consultas de usuarios de la tienda',
    storeRemarkName: 'Apodo de tienda',
    storeRemarkNameTip: 'Nota: Si el idioma compatible con el sistema no satisface sus necesidades, puede introducir aquí el apodo de tienda en el idioma que desea.',
    storeSearch: 'Consulta de tiendas',
    storeServicePhone: 'Número de teléfono de servicio',
    storeServicePhoneTip: 'Nota: Este número se utiliza para el contacto telefónico con el cliente, asegúrese de que el número de teléfono sea correcto.',
    storeServiceTime: 'Hora de apertura',
    storeStatistics: 'Estadísticas de tiendas',
    storeUploadImageRequire: 'Requisitos de formato de imagen para jpg/jpeg/png, se recomienda que el tamaño de una sola imagen no exceda de 5 MB, y se puede importar un total de 9 o menos imágenes.',
    storefront: 'Tienda',
    submissionFailed: 'Error al enviar, por favor, inténtalo de nuevo.',
    submit: 'Enviar',
    submitAccountDeleteApply: 'Envíe la solicitud de eliminación de cuenta',
    submitDataDeleteApply: 'Envíe la solicitud de eliminación de datos',
    submitFeedback: 'Enviar comentarios',
    submitForReview: 'Enviar para revisión',
    submitted: 'Presentado',
    successful: 'Correcto',
    sunday: 'Domingo',
    supportMapDown: 'Se admite la descarga de mapas sin conexión.',
    supportedChannel: 'Canales de asistencia',
    sureAgree: '¿De acuerdo?',
    sureBackApply: '¿Retirar la solicitud de eliminación de cuenta?',
    sureDelete: 'Una vez eliminado, no se puede recuperar. ¿Estás seguro de que quieres eliminarlo',
    sureDeleteData: '¿Seguro de eliminar los datos seleccionados? Una vez confirmados, los datos serán eliminados inmediatamente y no pueden recuperarse.',
    sureDeleteSeries: '¿Eliminar esta Serie?',
    sureDeleteSetting: '¿Está seguro de borrar esta configuración de pago?',
    sureDeleteStoreInfo: '¿Confirmar la eliminación de la información de esta tienda? Después de la eliminación, la información no será recuperable',
    sureReject: '¿Está seguro de rechazar?',
    sureSuspend: 'El envío se detendrá después de la terminación. ¿Estás seguro de que quieres cancelar',
    suspend: 'Terminar',
    sv_SE: 'Sueco',
    switchLanguage: 'Cambiar el idioma',
    system: 'Sistema',
    systemBusy: 'El sistema está ocupado, inténtalo de nuevo más tarde',
    systemVersion: 'Versión del sistema',
    tboxInstall: 'Post-instalación del TBox',
    tboxIntro: 'T-Box es el dispositivo clave para realizar la función de conexión de red inteligente de los vehículos',
    teamConfigTip: 'Los paseos (equipo todoterreno) estarán disponible para las motos que cumplen las condiciones de configuración anteriores, y usted tiene que pagar una cuota después de la función está disponible',
    threeMonths: 'Tres meses',
    thursday: 'Jueves',
    time: 'Tiempo',
    timeSend: 'Envío cronometrado',
    timedOffline: 'Tiempo fuera de línea programado',
    timedPush: 'Push temporizado',
    timedRelease: 'Publicación programada',
    timedSendTime: 'Hora de envío',
    tips: 'Consejos',
    title: 'Título',
    to: 'A',
    toBeReleased: 'Por publicar',
    topMenu: 'Menú superior',
    topicContent: 'Contenido de tema',
    topicList: 'Lista de temas',
    topicManagement: 'Gestión de temas',
    topicSearch: 'Consulta de temas',
    topicTitle: 'Título de tema',
    totalAndlLayoutOfStores: 'Número total y distribución de las tiendas',
    totalClicks: 'Total de clics',
    totalNumber: 'Veces totales',
    tr_TR: 'Turco',
    triggerNum: 'Número de desencadenantes',
    tuesday: 'Martes',
    turnOn: 'Abrir',
    twoCarAndFourCarOfNumber: 'Número de usuarios de dos y cuatro ruedas',
    twoCarOfNumber: 'Número de usuarios de vehículos de dos ruedas',
    twoWheelConfig: 'Configuración de la moto de dos ruedas para adultos',
    twoWheeler: 'Vehículos de dos ruedas',
    twoWheelerAndFourWheeler: 'Vehículos de dos y cuatro ruedas',
    twoWheelerMostClicks: 'Modelos de dos ruedas con más clics',
    twoWheelowner: 'Propietarios de motos de dos ruedas para adultos',
    type: 'Tipo',
    typeMessage: 'Tipo de comentarios',
    types: 'Tipo',
    unbind: 'Desvinculado',
    unbindingCommitment: 'Compromiso de desvinculación',
    unbindingLabelRealName: 'Nombre completo',
    unbound: 'Desvinculado',
    understandRealtimeConditions: 'Reciba vibraciones del vehículo y mensajes recordatorios de entrada y salida de vallas electrónicas, y comprenda el estado del vehículo en tiempo real.',
    uninstallTboxDesc: 'Para los vehículos que no tienen una T-Box instalada, puede ver información básica del vehículo, como el número de bastidor, el número de motor y el manual electrónico después de la vinculación.',
    unitCurrencyPer: 'Moneda por unidad',
    unitMonth: 'Mes',
    unlimited: 'Ilimitado',
    unpaid: 'No pagado',
    unprocessed: 'Sin procesar',
    unresolved: '¿Aún no puedes resolver? Hacer clic',
    unspecified: 'Es secreto',
    upToTopics: 'Se pueden añadir hasta %s temas',
    updateAuthenticationTime: 'Actualizar tiempo de autenticación',
    updateBy: 'Actualizador',
    updateSuccess: 'Actualización completada',
    updateTime: 'Tiempo de actualización',
    updating: 'actualizando',
    upgradeAgainDescription: 'La tarea de actualización se ha vuelto a enviar. Siga la 【Guía】 en la parte superior de la página actual para conectar la red de pantalla tft y actualizar.',
    upgradeAssistant: 'Ayuda',
    upgradeDescription: 'Cuando encuentre una nueva versión, siga la 【Guía】 en la parte superior de la página actual para conectar la red de pantalla TFT y actualizar.',
    upgradeSuccessful: 'Actualización exitosa',
    upgradeType: 'Método de actualización',
    upload: 'Subir',
    uploadDisplayPicture: 'Por favor, sube la imagen para mostrar',
    uploadFail: 'Error al subir',
    uploadFailed: 'La carga falló, intente con otra red.',
    uploadFailedOfTry: 'Error en la carga, inténtelo nuevamente',
    uploadFileMore1M: 'El tamaño del archivo de carga no supera los 1 M',
    uploadFiles: 'Subir archivo',
    uploadImageRules1To1: 'El formato de la imagen requiere jpg/jpeg/png, la escala de la imagen es de 1: 1 y el tamaño no supera los 5 MB',
    uploadLog: 'Cargar registro',
    uploadPicture: 'Subir imagen',
    uploadQuantityExceed: 'El número de cargas supera el límite',
    uploadSuccessful: 'Subir con éxito',
    uploadTime: 'Tiempo de carga',
    uploadTip556_740: 'Sube una imagen con un ancho y alto de 556 x 740',
    uploadVideoRules: 'Solo se admite la carga única de archivos de video. Se recomienda que el tamaño de un solo vídeo no supere los 50 MB.',
    uploadVideoRules4To3: 'Soporte de formato de vídeo, escala recomendada 4:3, tamaño no superior a 50 MB',
    urlLink: 'Enlace URL',
    user: 'Usuario',
    userAccount: 'Cuenta de usuario',
    userEmail: 'E-mail',
    userGender: 'Género del usuario',
    userId: 'ID de usuario',
    userIdTemplate: 'Plantilla de importación de ID de usuario',
    userIdentity: 'ID',
    userLocalTime: 'Hora de usuario final',
    userLogin: 'Iniciar sesión',
    userMobilePhone: 'Teléfono móvil',
    userModel: 'Modelo de usuario',
    userName: 'Nombre de usuario',
    userName1: 'Nombre de usuario',
    userNickname: 'Apodo del usuario',
    userNum: 'Número de usuario',
    userPhone: 'Número de teléfono móvil',
    userRealName: 'Nombre real',
    userReply: 'Pendiente de respuesta del usuario',
    userStatus: 'Estado del usuario',
    userType: 'Tipo de usuario',
    userUnbind: 'Desvinc. de usuario',
    users: 'Usuarios',
    vacationTime: 'Tiempo de vacaciones',
    validNumberVolume: 'Número de objetivos válidos',
    validNumerDescription: 'Número de dispositivos restantes tras filtrar el grupo objetivo seleccionado para el envío de tareas',
    validateAfter24Hours: 'Solo se admiten selecciones de tiempo futuras en un plazo de 24 horas',
    validateEmail: 'El formato de la dirección de correo electrónico es incorrecto. Por favor, compruébelo.',
    validateImageRadio: 'Requisitos de formato de archivos de imagen: %s, escala de imagen: %s, no más de %s',
    validateImageSize: 'Requisitos de formato de archivos de imagen: %s, tamaño de imagen recomendado: %s, no más de %s',
    validatePhone: 'El formato del número de teléfono es incorrecto. Por favor, compruébelo.',
    validateVideo: 'Requisitos de formato de archivos de vídeo: %s, no más de %s',
    validateVin: 'El número de identificación del vehículo (VIN) es incorrecto. Por favor, compruébelo.',
    validationCodeError: 'Error en el código de verificación',
    vechicleFirstBindTime: 'Hora real de primera vinculación del vehículo',
    vehicleAlarmDetails: 'Detalles de la alarma del vehículo',
    vehicleBindDuration: 'Duración de la vinculación del vehículo',
    vehicleBrochure: 'Folleto del vehículo',
    vehicleColor: 'Color del vehículo',
    vehicleDetails: 'Detalles del vehículo',
    vehicleDrivingLicense: 'Certificado de registro de vehículo',
    vehicleFaultDetails: 'Detalles del fallo del vehículo',
    vehicleGallery: 'Galería de vehículos',
    vehicleGalleryEntranceConfiguration:
      'Las imágenes de la página de la sala de exposición de motocicletas de la aplicación y de la entrada a la función de galería de vehículos se toman de la siguiente configuración. Asegúrese de que las tres imágenes estén completas en la configuración.',
    vehicleGalleryEntranceSettings: 'Configuración de entrada a la galería de vehículos',
    vehicleGalleryUploadRules: 'El requisito de formato de imagen es jpg/jpeg/png. Se recomienda que el tamaño de una sola imagen no supere los 5 MB. Se puede importar un máximo de 10 imágenes a la vez. Se permiten múltiples importaciones.',
    vehicleIdHomepageImage: 'Página principal del Certificado de Registro de Vehículo con el nombre del propietario y el número de identificación del vehículo (VIN).',
    vehicleModel: 'Modelo de vehículo',
    vehicleModelAlbum: 'Catálogo de vehículos',
    vehicleModelCategorySort: 'Ordenar por categoría de vehículo',
    vehicleModelDescription: 'Descripcion del modelo',
    vehicleModelList: 'Lista de modelos',
    vehicleModelManagement: 'Gestión de modelos de vehículos',
    vehicleModelName: 'Nombre del modelo',
    vehicleModelQuery: 'Consulta de modelo de vehículo',
    vehicleModelSeries: 'Serie de modelos',
    vehicleModelSorting: 'Clasificación de modelos',
    vehicleModelType: 'Tipo de modelo',
    vehicleName: 'Nombre del vehículo',
    vehicleNetworkEquipment: 'Dispositivo de red de vehículos',
    vehicleOutboundCountry: 'Países en los que los vehículos salen del almacén',
    vehicleRemark: 'Observaciones del vehículo',
    vehicleShareInstruction: 'Instrucciones para compartir vehículos',
    vehicleShareInstructionAdd: 'Instrucciones para compartir nuevos vehículos',
    vehicleShareInstructionEdit: 'Editar instrucciones para compartir vehículos',
    vehicleType: 'Número de motor',
    vehicleTypeSplicing: 'Modelo de retroalimentación',
    vehicleUnbindingInstructions: 'Instrucciones para solicitar la desvinculación de vehículos',
    verifyCodeSendFail: 'No se pudo enviar el código de verificación',
    verifyCodeSendSuccess: 'Envío correcto de Código de verificación',
    versionCode: 'Número de versión',
    versionIntroduction: 'Introducción a la versión',
    versionManage: 'Gestión de versiones',
    versionManageList: 'Lista de gestión de versiones',
    versionMangeTip:
      'Nota: ¡No está permitido crear una versión mayor que el número de versión publicado actualmente en el mercado de aplicaciones! El personal de operación y mantenimiento debe esperar a que se publique la última versión en Google Play o App Store y luego crear registros de versión correspondientes al número de versión más reciente. No se permite crear registros por adelantado.',
    versionPattern: 'El número de versión solo se puede ingresar como un número entero del 0 al 999',
    versionRequired: 'El número de versión no puede estar vacío',
    vhDataBasicService: 'Servicio básico de datos del vehículo',
    video: 'Video',
    videoContent: 'Contenido de vídeo',
    videoCover: 'Portada del vídeo',
    videoDetail: 'Detalles del vídeo',
    videoDisplayImages: 'Visualización de vídeo',
    videoFile: 'Archivo de vídeo',
    videoGuide: 'Configuración de arranque de vídeo',
    videoImageValidate: 'Requisitos del formato de archivo de imagen: formato png/jpg/jpeg, relación de imagen 16:9, no más de 5 MB de tamaño.',
    videoList: 'Lista de vídeos',
    videoMaxSizeValidate: 'El tamaño del vídeo no puede exceder los 150 MB.',
    videoSizeExceed: 'Por favor, suba un video de %s de ancho y altura',
    viewAllComment: 'Ver todos los comentarios',
    viewCount: 'Recuento de visualizaciones',
    viewCurrentLocation: 'Abra la aplicación para ver la ubicación actual del vehículo en cualquier momento',
    viewCurrentLocation2: 'Abra la aplicación para ver la ubicación actual del vehículo en cualquier momento, lo cual es conveniente para encontrar vehículos a corta distancia',
    viewDetails: 'Ver detalles',
    viewFeedBackRecords: 'Ver registros de comentarios',
    viewLocation: 'Abre la aplicación para consultar la ubicación del vehículo en cualquier momento',
    viewModel: 'Ver este modelo',
    viewPush: 'Ver empuje',
    viewSeries: 'Ver la serie',
    viewVehicleInfomation: 'Soporte para ver la pista de conducción diaria, kilometraje, duración, velocidad y otra información del vehículo.',
    views: 'Puntos de vista',
    vin: 'VIN',
    virginia: 'Virginia',
    waitForReview: 'Esperando revisión',
    waitUploading: 'Cargando, espere, por favor',
    waitingManualReview: 'Esperando revisión manual',
    waitingOnline: {},
    waitingPush: 'Esperando',
    wednesday: 'Miércoles',
    whatOTA: '¿Qué es OTA?',
    whyUseNavigation: 'Cómo utilizar la navegación',
    whyUseSetting: 'Cómo hacer la configuración general de la aplicación',
    withCountry: 'País/región (IP)',
    withInformation: 'Con información',
    withTBOX: 'Con TBOX',
    withdrawn: 'Retirado',
    withoutCarOfNumber: 'Número de usuarios sin vehículo',
    withoutTBOX: 'Sin TBOX',
    writeAccountToPass: 'Rellene la información de la cuenta y complete la verificación de identidad',
    year: 'Año',
    yes: 'Sí',
    youHaveFeedbackMessage: 'Tiene ** comentarios de los usuarios que no se han seguido de manera efectiva, trátelos a tiempo',
    youthVehicleOwner: 'Propietarios de motos no adultos',
    yoyGrowth: 'Aumento interanual',
    zh_CN: 'Chino',
  },
};
